import vars from '@/config/vars';
import axios from '@/config/axios.config';

export function FetchPostalCodeAsync(postalCode) {
    if (vars.USE_SIMULATED_MODE)
        return FetchSimulatedPostalCode(postalCode);
    
    return FetchProductionPostalCode(postalCode);
}

function FetchProductionPostalCode(postalCode) {
    let response = axios.get(`AddressSearch/${postalCode}`);

    return response;
}

function FetchSimulatedPostalCode() {
    return new Promise(resolve => {
        setTimeout(() => {
            const data = {
                street: 'Avenida Marechal Câmara',
                district: 'Centro',
                city: 'Rio de Janeiro',
                state: 'RJ'
            };

            resolve({
                data
            });
        }, 1000);
    });
}